<div
  class="create-annotation"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (touchstart)="touchStartEvent($event)"
  (touchend)="touchEndEvent($event)"
>
  <app-view-annotation
    [sideMenuOpen]="sideMenuOpen"
    [hideClose]="true"
    [asset]="asset"
    [scale]="scale"
    [offsetX]="offsetX"
    [offsetY]="offsetY"
    [offsetScale]="offsetScale"
    [shapes]="shapes"
    [noAnimate]="noAnimate"
    [isDesktop]="isDesktop"
  ></app-view-annotation>
</div>
